import { IBaseConfig } from "@models/form/base-config";
import { HardFormFieldTypeEnum, IHardFormField } from "@hardcode-kz/ui";
import { Validators } from "@angular/forms";

export class GridScreenConfig implements IBaseConfig {
  version = 1;

  fields: IHardFormField<any>[] = [
    {
      name: "screenSize",
      title: "Размер экрана",
      params: {
        direction: "row",
        fields: [
          {
            name: "minWidth",
            type: HardFormFieldTypeEnum.Number,
            title: "Мин.ширина",
            placeholder: "1000",
            params: {
              validators: [Validators.required],
            },
          },
          {
            name: "maxWidth",
            type: HardFormFieldTypeEnum.Number,
            title: "Макс.ширина",
            placeholder: "1000",
            params: {
              validators: [Validators.required],
            },
          },
          {
            name: "minHeight",
            type: HardFormFieldTypeEnum.Number,
            title: "Мин.высота",
            placeholder: "1000",
            params: {
              validators: [Validators.required],
            },
          },
          {
            name: "maxHeight",
            type: HardFormFieldTypeEnum.Number,
            title: "Макс.высота",
            placeholder: "1000",
            params: {
              validators: [Validators.required],
            },
          },
        ],
      },
    },
  ];
}
